// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-link .las[data-v-3514a774] {
  font-size: 20px;
}
.menuHeaderThin[data-v-3514a774] {
  width: 100%;
}
.helpText[data-v-3514a774] {
  margin-bottom: 0.2rem;
}
.helpText a[data-v-3514a774],
.helpText span[data-v-3514a774] {
  color: white;
  user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  -webkit-user-select: text;
}
nav#left-menu-mobile .helpDiv[data-v-3514a774] {
  position: absolute;
  bottom: 20px;
  width: 100%;
  height: 50px;
  margin-left: 5px;
}
.toggler[data-v-3514a774] {
  padding: 0px;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/np-navbar.vue","webpack://./np-navbar.vue"],"names":[],"mappings":"AACA;EACI,eAAA;ACAJ;ADGI;EACI,WAAA;ACDR;ADGI;EACI,qBAAA;ACDR;ADGI;;EACI,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,qBAAA;EACA,yBAAA;ACAR;ADGI;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;ACDR;ADGI;EACE,YAAA;ACDN","sourcesContent":["\n.nav-link .las {\n    font-size: 20px;\n}\n\n    .menuHeaderThin {\n        width: 100%;\n    }\n    .helpText {\n        margin-bottom: 0.2rem;\n    }\n    .helpText a, .helpText span {\n        color: white;\n        user-select: text;\n        -moz-user-select: text;\n        -ms-user-select: text;\n        -webkit-user-select: text;\n    }\n\n    nav#left-menu-mobile .helpDiv{\n        position: absolute;\n        bottom: 20px;\n        width: 100%;\n        height: 50px;\n        margin-left: 5px;\n    }\n    .toggler {\n      padding: 0px;\n    }\n",".nav-link .las {\n  font-size: 20px;\n}\n.menuHeaderThin {\n  width: 100%;\n}\n.helpText {\n  margin-bottom: 0.2rem;\n}\n.helpText a,\n.helpText span {\n  color: white;\n  user-select: text;\n  -moz-user-select: text;\n  -ms-user-select: text;\n  -webkit-user-select: text;\n}\nnav#left-menu-mobile .helpDiv {\n  position: absolute;\n  bottom: 20px;\n  width: 100%;\n  height: 50px;\n  margin-left: 5px;\n}\n.toggler {\n  padding: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
